import React from 'react'

const SelectButton = ({values,height,width,border,setOnTotal}) => {
    const handleChange = (e) => {
        const selectedValue = e.target.value;
        if(selectedValue === 'On Total'){
            setOnTotal(false)
        }
        else{ 
            setOnTotal(true)
        }
        
      }
    
  return (
    <div>
      <select style={{ height: `${height}px`,
                       width: `${width}px`,
                       border: '1px solid rgb(226, 226, 226)',
                       borderRadius: `${border ? border : '10px'}`,
                       padding: '15px',
                       backgroundColor: 'transparent'}}
                       onChange={handleChange}>
        {
            values?.map((val,index) => (
                <option key={index}>{val}</option>
            ))
        }
      </select>
    </div>
  )
}

export default SelectButton
